// Make optional so that superRefine can be called
import { z } from 'zod';
// superRefine requires child objects to be valid to even validate to begin with
export const strikeSchema = z.object({
    underlying_id: z.coerce.number().int().positive().min(0).optional(),
    value: z.number().optional(),
    percent: z.number().min(0).max(100).optional(),
});
